{
	"DisplayAsLabel": "Display as:",
	"ColorTileBackgroundLabel": "Tile Colour:",
	"ColorTileTextLabel": "Text Colour:",
	"FitImageLabel": "Fit Image",
	"DisplayTitleLabel": "Display title text area",
	"AutoValuePlaceholder": "[Auto]",
	"ImageUrlPlaceholder": "https://example.com/image.png",
	"ImageUrlLabel": "Image URL:",
	"Black": "Black",
	"White": "White",
	"Blanc": "Blanc",
	"Smoke": "Smoke",
	"Grey": "Grey",
	"Battleship": "Battleship",
	"Aqua": "Aqua",
	"VividSky": "Vivid Sky",
	"Blue": "Blue",
	"ElectricIndigo": "Electric Indigo",
	"Waters": "Waters",
	"Sky": "Sky",
	"Akixi": "Akixi",
	"Midnight": "Midnight",
	"OxfordBlue": "Oxford Blue",
	"Pistachio": "Pistachio",
	"Aquamarine": "Aquamarine",
	"Green": "Green",
	"Forest": "Forest",
	"Salmon": "Salmon",
	"Red": "Red",
	"Rosita": "Rosita",
	"Peach": "Peach",
	"Orange": "Orange",
	"Clementine": "Clementine",
	"Amarelo": "Amarelo",
	"Yellow": "Yellow",
	"Sunflower": "Sunflower",
	"Lilac": "Lilac",
	"Purple": "Purple",
	"Regal": "Regal",
	"Blush": "Blush",
	"Pink": "Pink",
	"Fuchsia": "Fuchsia",
	"Caribbean": "Caribbean",
	"Teal": "Teal",
	"Peacock": "Peacock",
	"SimpleTextValue": "[Simple Text Value]",
	"ProgressRing": "Progress Ring",
	"GradatedDial": "Gradated Dial",
	"GlideSlope": "Glide Slope",
	"Bullseye": "Bullseye",
	"BarGauge": "Bar Gauge",
	"ConeGauge": "Cone Gauge",
	"DashboardSpeedometerBlack": "Dashboard Speedometer (Black)",
	"DashboardSpeedometerAmber": "Dashboard Speedometer (Amber)",
	"DashboardTemperatureGauge": "Dashboard Temperature Gauge",
	"DashboardFuelGauge": "Dashboard Fuel Gauge",
	"DashboardPowerGauge": "Dashboard Power Gauge",
	"DashboardColourGauge": "Dashboard Colour Gauge",
	"GaugeFaceLabel": "Reverse gauge face:",
	"GaugeFaceDirection": "Reverse gauge direction:",
	"MaxScaleLabel": "Max scale:",
	"DisplayPreviewCaption": "Preview:",
	"NAME": "DisplaySettings",
	"DisplaySettings_SectionHeader": "Display settings"
}